import "../Styles/demo.css";

import {
  FaInstagram,
  FaTiktok,
  FaFacebookF,
  FaWhatsapp,
  FaGlobe,
  FaGoogle,

} from "react-icons/fa";
import { useState, useEffect } from "react";
import api from "./Api";
import { useParams } from "react-router-dom";
import { toast } from "sonner";


export default function DemoPage() {
    const [business, setBusiness] = useState(null);
    const [loading, setLoading] = useState(true);
    const [, setError] = useState("");
    const { slug } = useParams();

   useEffect(() => {
  if (!slug) return;

  let ignore = false;

  const fetchBusiness = async () => {
    try {
     
      setError("");

      const res = await api.get(`/get-business/${slug}`);
 setLoading(false);
      if (!ignore) {
        setBusiness(res.data.business);
      }
    } catch (err) {
      if (!ignore) {
        setError(err.response?.data?.message || "Business not found");
        toast.error(err.response?.data?.message ||  "Failed to load business data");
      }
    } finally {
      if (!ignore) setLoading(false);
    }
  };

  fetchBusiness();

  return () => {
    ignore = true;
  };
}, [slug]);
  return (
    <div >{loading ? <p style={{width:'100%'}}>Loading...</p> : <div className="demo-container">
      {/* BUSINESS DISPLAY */}
      <div className="business-side">
        <div className="business-card">
          <div className="glow" />

          <img
            src={business?.logoUrl}
            alt="logo"
            className="business-logo"
          />

          <h1>{business?.businessName}</h1>

          <p>
            Scan to leave a review, follow us or contact us instantly.
          </p>

          <div className="qr-box">
            <img
              src={business?.qrCodeUrl}
              alt="qr-code"
              className="qr-image"
            />
          </div>

          <div className="tag-row">
            <span>
              <FaGoogle />
              Reviews
            </span>

            <span>
              <FaInstagram />
              Socials
            </span>

            <span>
              <FaWhatsapp />
              Contact
            </span>
          </div>
          <div className="powered-by">
  <span>Powered by</span>

  <a
    href="https://www.clusterclear.com"
    target="_blank"
    rel="noreferrer"
  >
    ClusterClear
  </a>
</div>
        </div>
        
      </div>

      {/* CUSTOMER VIEW */}
      <div className="phone-wrapper">
        <div className="phone">
          <div className="phone-top" />

          <div className="customer-header">
            <img
              src={business?.logoUrl}
              alt="logo"
              className="customer-logo"
            />

            <h2>{business?.businessName}</h2>
<div className="about-card">
  <p>
    Fresh coffee, pastries & community vibes in the heart of the city.
    Visit us for the best local experience.
  </p>
</div>
            <p>Everything in one place</p>
          </div>

          <div className="link-buttons">
            <a href={business?.reviewLinks?.google}  rel="noreferrer" target="_blank">
              <FaGoogle />
              Leave Google Review
            </a>

            <a href={business?.socialLinks.instagram} rel="noreferrer"target="_blank">
              <FaInstagram />
              Instagram
            </a>

            <a href={business?.socialLinks.tiktok} rel="noreferrer" target="_blank">
              <FaTiktok />
              TikTok
            </a>

            <a href={business?.socialLinks.facebook}  rel="noreferrer"target="_blank">
              <FaFacebookF />
              Facebook
            </a>

            <a href={business?.whatsappNumber} rel="noreferrer" target="_blank">
              <FaWhatsapp />
              WhatsApp
            </a>

            <a href={business?.website} rel="noreferrer" target="_blank">
              <FaGlobe />
              Website
            </a>
          </div>
<div className="powered-by">
  <span>Powered by</span>

  <a
    href="https://www.clusterclear.com"
    target="_blank"
    rel="noreferrer"
  >
    ClusterClear
  </a>
</div>
        </div>
      </div>
    </div>}</div>
    
  );
}